import { Controller } from "@hotwired/stimulus"

// Auto-submits a form when an input changes
// Usage: data-controller="auto-submit" on form, data-action="change->auto-submit#submit" on input
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}

